"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.E2EWalletAdapter = exports.E2EWalletName = void 0;
const wallet_adapter_base_1 = require("@solana/wallet-adapter-base");
const web3_js_1 = require("@solana/web3.js");
exports.E2EWalletName = "E2E";
class E2EWalletAdapter extends wallet_adapter_base_1.BaseWalletAdapter {
    constructor(config = {}) {
        super();
        this.name = exports.E2EWalletName;
        this.url = "https://E2E.app";
        this.icon = "E2E";
        this._connecting = false;
        this._wallet = null;
        this._underlyingWallet = config.keypair || web3_js_1.Keypair.generate();
        this._publicKey = this._underlyingWallet.publicKey;
        this._readyState = wallet_adapter_base_1.WalletReadyState.Installed;
        this._approveNext = true;
        if (typeof window !== "undefined") {
            window.solanaE2E = this;
        }
    }
    get publicKey() {
        return this._publicKey;
    }
    get connecting() {
        return this._connecting;
    }
    get connected() {
        return !!this._publicKey;
    }
    get readyState() {
        return this._readyState;
    }
    rejectNext() {
        this._approveNext = false;
    }
    _checkForReject() {
        if (!this._approveNext) {
            this._approveNext = true;
            throw new Error("E2E wallet rejected transaction");
        }
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            this._connecting = true;
            this._publicKey = this._underlyingWallet.publicKey;
            this._connecting = false;
            this.emit("connect", this._publicKey);
        });
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this._wallet = null;
            this._publicKey = null;
            this.emit("disconnect");
        });
    }
    sendTransaction(transaction, connection, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            this._checkForReject();
            transaction = yield this.prepareTransaction(transaction, connection);
            const { signers } = options, sendOptions = __rest(options, ["signers"]);
            const signature = yield connection.sendTransaction(transaction, [
                this._underlyingWallet,
            ]);
            return signature;
        });
    }
    signTransaction(transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            this._checkForReject();
            transaction.sign(this._underlyingWallet);
            return transaction;
        });
    }
    signAllTransactions(transactions) {
        return __awaiter(this, void 0, void 0, function* () {
            this._checkForReject();
            for (let i = 0; i < transactions.length; i++) {
                transactions[i].sign(this._underlyingWallet);
            }
            return transactions;
        });
    }
}
exports.E2EWalletAdapter = E2EWalletAdapter;
